import { render } from "./SongTitlePopup.vue?vue&type=template&id=415ab53d&scoped=true"
import script from "./SongTitlePopup.vue?vue&type=script&lang=js"
export * from "./SongTitlePopup.vue?vue&type=script&lang=js"

import "./SongTitlePopup.vue?vue&type=style&index=0&id=415ab53d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415ab53d"]])

export default __exports__